import { call, takeEvery } from 'redux-saga/effects';
import { setLeadDuplicate } from '../../requests/change_leads_status_request';
import { message_error, message_success } from '../../../../../components/Message';

function* setLeadProfileDuplicate({ root_id, isDuplicate }) {
    const { result, error } = yield call(setLeadDuplicate, root_id, isDuplicate);
    result
        ? message_success('Lead marked as duplicate!')
        : message_error(error);
}

export default function* setLeadProfileDuplicateSaga() {
    yield takeEvery('SET_LEAD_PROFILE_DUPLICATE_REQUEST', setLeadProfileDuplicate);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/set_lead_profile_duplicate.saga.js